import { NgxCurrencyDirective } from 'ngx-currency';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { BaseUiModule, CurrencyInputComponent } from '@mitsubishi/shared/ui';

import { ApmProjectCurrencyPipe } from '../pipes/apm-project-currency.pipe';
import { AccessoryPriceComponent } from './accessory-price.component';

@NgModule({
  declarations: [AccessoryPriceComponent],
  imports: [
    CommonModule,
    BaseUiModule,
    FormsModule,
    ApmProjectCurrencyPipe,
    NgxCurrencyDirective,
    CurrencyInputComponent,
  ],
  exports: [AccessoryPriceComponent],
})
export class AccessoryPriceModule {}
